var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',[_c('b-field',[_c('b-checkbox',{model:{value:(_vm.value.bubbleActive),callback:function ($$v) {_vm.$set(_vm.value, "bubbleActive", $$v)},expression:"value.bubbleActive"}},[_vm._v("Bulle activée")])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }